class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.closeOnBackdropClick = this.hasAttribute("close-on-backdrop-click");
    this.querySelector('[id^="ModalClose-"]')?.addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.querySelectorAll("[data-modal-close], [data-fancybox-close]").forEach(
      (el) => {
        el.addEventListener("click", this.hide.bind(this, false));
      }
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    this.querySelector('[role="dialog"]')?.addEventListener(
      "click",
      (event) => {
        this._handleBackdropClick(event);
      }
    );
  }

  show(opener = null) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.documentElement.classList.add("overflow-hidden");
    document.body.classList.add("overflow-hidden");
    this.querySelector('[role="dialog"]')?.showModal();
    this.open = true;
    if (popup) popup.loadContent();
    if (opener) this._focusOnFirstElement();
    if (typeof window.pauseAllMedia === 'function') window.pauseAllMedia();
  }

  hide() {
    document.documentElement.classList.remove("overflow-hidden");
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.querySelector('[role="dialog"]')?.close();
    this.open = false;
    if (this.openedBy) {
      this.openedBy.focus();
    }
    if (typeof window.pauseAllMedia === 'function') window.pauseAllMedia();
  }

  _focusOnFirstElement() {
    try {
      setTimeout(async () => {
        const dialog = await this.querySelector('[role="dialog"]');
        if (dialog) {
          const firstFocusableElement = dialog.querySelector(
            'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
          );

          if (firstFocusableElement) {
            firstFocusableElement.focus();
          }
        }
      }, 300);
    } catch (error) {
      console.error("Error in _focusOnFirstElement", error);
    }
  }

  _handleBackdropClick(event) {
    if (!this.closeOnBackdropClick) {
      return;
    }

    if (
      event.target instanceof HTMLElement &&
      event.target.tagName === "DIALOG"
    ) {
      this.hide();
    }
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("dialog-toggle", ModalOpener);
